/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShockEventChartDataPoint } from './ShockEventChartDataPoint';
import {
    ShockEventChartDataPointFromJSON,
    ShockEventChartDataPointFromJSONTyped,
    ShockEventChartDataPointToJSON,
    ShockEventChartDataPointToJSONTyped,
} from './ShockEventChartDataPoint';
import type { ShockEventsPerEntity } from './ShockEventsPerEntity';
import {
    ShockEventsPerEntityFromJSON,
    ShockEventsPerEntityFromJSONTyped,
    ShockEventsPerEntityToJSON,
    ShockEventsPerEntityToJSONTyped,
} from './ShockEventsPerEntity';
import type { MaintenanceChartDataPoint } from './MaintenanceChartDataPoint';
import {
    MaintenanceChartDataPointFromJSON,
    MaintenanceChartDataPointFromJSONTyped,
    MaintenanceChartDataPointToJSON,
    MaintenanceChartDataPointToJSONTyped,
} from './MaintenanceChartDataPoint';
import type { UtilizationPerVehicle } from './UtilizationPerVehicle';
import {
    UtilizationPerVehicleFromJSON,
    UtilizationPerVehicleFromJSONTyped,
    UtilizationPerVehicleToJSON,
    UtilizationPerVehicleToJSONTyped,
} from './UtilizationPerVehicle';

/**
 * 
 * @export
 * @interface Dashboard
 */
export interface Dashboard {
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    severeImpactsToday: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    licensesExpiringNextMonth: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    leaseContractsExpiringNextSixMonths: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    vehiclesOverdueForMaintenanceNow: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    vehiclesInMaintenanceNow: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    totalOperatingSecondsToday: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    totalFleetUsersLoggedInToday: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    totalElofleetVehicles: number;
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    activeVehiclesToday: number;
    /**
     * List of shock event chart data points within the specified shock event chart period.
     * @type {Array<ShockEventChartDataPoint>}
     * @memberof Dashboard
     */
    shockEventChartData: Array<ShockEventChartDataPoint>;
    /**
     * 
     * @type {Array<MaintenanceChartDataPoint>}
     * @memberof Dashboard
     */
    maintenanceChartData: Array<MaintenanceChartDataPoint>;
    /**
     * The five vehicles with the most shock events within the specified top vehicles by shock events period.
     * @type {Array<ShockEventsPerEntity>}
     * @memberof Dashboard
     */
    topVehiclesByShockEvents: Array<ShockEventsPerEntity>;
    /**
     * The five users with the most shock events within the specified top users by shock events period.
     * @type {Array<ShockEventsPerEntity>}
     * @memberof Dashboard
     */
    topUsersByShockEvents: Array<ShockEventsPerEntity>;
    /**
     * The five vehicles with the lowest utilization within the specified vehicle utilization period.
     * @type {Array<UtilizationPerVehicle>}
     * @memberof Dashboard
     */
    vehicleUtilization: Array<UtilizationPerVehicle>;
    /**
     * Mean utilization of all vehicles in the last 24 hours as a value between 0 and 1.
     * @type {number}
     * @memberof Dashboard
     */
    meanVehicleUtilization: number;
}

/**
 * Check if a given object implements the Dashboard interface.
 */
export function instanceOfDashboard(value: object): value is Dashboard {
    if (!('severeImpactsToday' in value) || value['severeImpactsToday'] === undefined) return false;
    if (!('licensesExpiringNextMonth' in value) || value['licensesExpiringNextMonth'] === undefined) return false;
    if (!('leaseContractsExpiringNextSixMonths' in value) || value['leaseContractsExpiringNextSixMonths'] === undefined) return false;
    if (!('vehiclesOverdueForMaintenanceNow' in value) || value['vehiclesOverdueForMaintenanceNow'] === undefined) return false;
    if (!('vehiclesInMaintenanceNow' in value) || value['vehiclesInMaintenanceNow'] === undefined) return false;
    if (!('totalOperatingSecondsToday' in value) || value['totalOperatingSecondsToday'] === undefined) return false;
    if (!('totalFleetUsersLoggedInToday' in value) || value['totalFleetUsersLoggedInToday'] === undefined) return false;
    if (!('totalElofleetVehicles' in value) || value['totalElofleetVehicles'] === undefined) return false;
    if (!('activeVehiclesToday' in value) || value['activeVehiclesToday'] === undefined) return false;
    if (!('shockEventChartData' in value) || value['shockEventChartData'] === undefined) return false;
    if (!('maintenanceChartData' in value) || value['maintenanceChartData'] === undefined) return false;
    if (!('topVehiclesByShockEvents' in value) || value['topVehiclesByShockEvents'] === undefined) return false;
    if (!('topUsersByShockEvents' in value) || value['topUsersByShockEvents'] === undefined) return false;
    if (!('vehicleUtilization' in value) || value['vehicleUtilization'] === undefined) return false;
    if (!('meanVehicleUtilization' in value) || value['meanVehicleUtilization'] === undefined) return false;
    return true;
}

export function DashboardFromJSON(json: any): Dashboard {
    return DashboardFromJSONTyped(json, false);
}

export function DashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'severeImpactsToday': json['severeImpactsToday'],
        'licensesExpiringNextMonth': json['licensesExpiringNextMonth'],
        'leaseContractsExpiringNextSixMonths': json['leaseContractsExpiringNextSixMonths'],
        'vehiclesOverdueForMaintenanceNow': json['vehiclesOverdueForMaintenanceNow'],
        'vehiclesInMaintenanceNow': json['vehiclesInMaintenanceNow'],
        'totalOperatingSecondsToday': json['totalOperatingSecondsToday'],
        'totalFleetUsersLoggedInToday': json['totalFleetUsersLoggedInToday'],
        'totalElofleetVehicles': json['totalElofleetVehicles'],
        'activeVehiclesToday': json['activeVehiclesToday'],
        'shockEventChartData': ((json['shockEventChartData'] as Array<any>).map(ShockEventChartDataPointFromJSON)),
        'maintenanceChartData': ((json['maintenanceChartData'] as Array<any>).map(MaintenanceChartDataPointFromJSON)),
        'topVehiclesByShockEvents': ((json['topVehiclesByShockEvents'] as Array<any>).map(ShockEventsPerEntityFromJSON)),
        'topUsersByShockEvents': ((json['topUsersByShockEvents'] as Array<any>).map(ShockEventsPerEntityFromJSON)),
        'vehicleUtilization': ((json['vehicleUtilization'] as Array<any>).map(UtilizationPerVehicleFromJSON)),
        'meanVehicleUtilization': json['meanVehicleUtilization'],
    };
}

export function DashboardToJSON(json: any): Dashboard {
    return DashboardToJSONTyped(json, false);
}

export function DashboardToJSONTyped(value?: Dashboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'severeImpactsToday': value['severeImpactsToday'],
        'licensesExpiringNextMonth': value['licensesExpiringNextMonth'],
        'leaseContractsExpiringNextSixMonths': value['leaseContractsExpiringNextSixMonths'],
        'vehiclesOverdueForMaintenanceNow': value['vehiclesOverdueForMaintenanceNow'],
        'vehiclesInMaintenanceNow': value['vehiclesInMaintenanceNow'],
        'totalOperatingSecondsToday': value['totalOperatingSecondsToday'],
        'totalFleetUsersLoggedInToday': value['totalFleetUsersLoggedInToday'],
        'totalElofleetVehicles': value['totalElofleetVehicles'],
        'activeVehiclesToday': value['activeVehiclesToday'],
        'shockEventChartData': ((value['shockEventChartData'] as Array<any>).map(ShockEventChartDataPointToJSON)),
        'maintenanceChartData': ((value['maintenanceChartData'] as Array<any>).map(MaintenanceChartDataPointToJSON)),
        'topVehiclesByShockEvents': ((value['topVehiclesByShockEvents'] as Array<any>).map(ShockEventsPerEntityToJSON)),
        'topUsersByShockEvents': ((value['topUsersByShockEvents'] as Array<any>).map(ShockEventsPerEntityToJSON)),
        'vehicleUtilization': ((value['vehicleUtilization'] as Array<any>).map(UtilizationPerVehicleToJSON)),
        'meanVehicleUtilization': value['meanVehicleUtilization'],
    };
}

